import { Link } from "@tanstack/react-router";
import { Button } from "@workspace/web-ui/components/button";
import { Card, CardTitle } from "@workspace/web-ui/components/card";
import { Form } from "@workspace/web-ui/components/form";
import { cn } from "@workspace/web-ui/lib/utils";
import { AlertCircle, ChevronLeft, Loader2 } from "lucide-react";
import { useReset } from "../hooks/use-reset";
import { FormFieldType } from "../types";
import FormField from "./formfield/form-field";

const inputStyles = "rounded-lg border border-[#DCDEE3]";

const ResetForm = () => {
    const { form, onSubmit, isLoading: isDataSubmitting, error } = useReset();

    return (
        <Card className="max-w-[550px] flex flex-col justify-center gap-6 w-full p-[32px] rounded-[10px] shadow-lg">
            <Link to="/" className="flex items-center gap-2 font-medium text-sm">
                <ChevronLeft size={20} />
                Back
            </Link>

           <div className="flex flex-col gap-2">
           <CardTitle className="text-[32px] leading-[40px] font-medium">Reset Password</CardTitle>
           <p className="text-[16px] leading-[24px] font-normal">Enter your email to receive a password reset link.</p>
           </div>

          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="w-full space-y-6" aria-label="Reset-Password form">
                <FormField
                    control={form.control}
                    name="email"
                    label="Email"
                    placeholder="Enter registered email address"
                    className={cn(inputStyles, error && "rounded-lg border-red-500 focus:border-red-500 focus:ring-red-500", "px-[16px] py-[20px]")}
                    error={form.formState.errors.email?.message}
                    type="email"
                    fieldType={FormFieldType.TEXT}
                />
                
                {error && (
                    <div className="flex gap-2 items-center">
                        <AlertCircle className="text-red-500 w-6 h-6"/>
                        <h2 className="text-sm font-medium text-red-500">{error}</h2>
                    </div>
                )}

                <Button
                    type="submit"
                    className="w-full px-[16px] py-[12px] h-10 rounded-[10px] bg-[#4272DD]"
                    disabled={isDataSubmitting}
                >
                  {isDataSubmitting ? <Loader2 className="animate-spin duration-200" /> : "Reset Password"}
                </Button>
            </form>
          </Form>

          <div className="flex items-center text-center justify-center gap-2 font-bold text-base text-[#2A6BFF] hover:underline">
          <Link to="/">
                Back to Login
            </Link>
          </div>
        </Card>
    )
}

export default ResetForm;